export default "__VITE_ASSET__2WN$pSUY__"